<template>
  <div class="container">
    <h1>Privacy Policy</h1>
  </div>
</template>

<script>
  export default {
    name: 'PrivacyPolicy'
  }
</script>

<style lang="scss" scoped>

</style>
